import { render, staticRenderFns } from "./NetvisorPurchaseInvoiceTable.vue?vue&type=template&id=0bc80507&scoped=true"
import script from "./NetvisorPurchaseInvoiceTable.vue?vue&type=script&lang=js"
export * from "./NetvisorPurchaseInvoiceTable.vue?vue&type=script&lang=js"
import style0 from "./NetvisorPurchaseInvoiceTable.vue?vue&type=style&index=0&id=0bc80507&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc80507",
  null
  
)

export default component.exports